import React from 'react'
import { Button, Icon, Card } from 'antd'
import JobCard from './JobCard'
import { getReviewDateCategory, parseDateOnly } from './utils'
import './styles.css'

const reviewDateStages = [
  { id: 'earlierThanYesterday', label: 'Earlier than yesterday', subtitle: 'Overdue' },
  { id: 'yesterday', label: 'Yesterday', subtitle: 'Past due' },
  { id: 'today', label: 'Today', subtitle: 'Due today' },
  { id: 'next7days', label: 'In the next 7 days', subtitle: 'Upcoming' },
  { id: 'beyond7days', label: 'Beyond 7 days', subtitle: 'Future' }
]

function Board({ jobCards, expandedColumnId, onCardClick, onToggleExpand }) {
  const getFilteredCardsForStage = (stageId) => {
    return jobCards.filter((card) => getReviewDateCategory(card) === stageId)
  }

  const sortCards = (cards) => {
    return [...cards].sort((a, b) => {
      const reviewDateA = parseDateOnly(a.reviewDate)
      const reviewDateB = parseDateOnly(b.reviewDate)

      if (reviewDateA && reviewDateB) {
        const reviewDiff = reviewDateA.getTime() - reviewDateB.getTime()
        if (reviewDiff !== 0) {
          return reviewDiff
        }
      } else if (reviewDateA && !reviewDateB) {
        return -1
      } else if (!reviewDateA && reviewDateB) {
        return 1
      }

      const complaintDateA = parseDateOnly(a.complaintDate)
      const complaintDateB = parseDateOnly(b.complaintDate)

      if (complaintDateA && complaintDateB) {
        return complaintDateA.getTime() - complaintDateB.getTime()
      } else if (complaintDateA && !complaintDateB) {
        return -1
      } else if (!complaintDateA && complaintDateB) {
        return 1
      }

      return 0
    })
  }

  const calculateColumns = (filteredCards) => {
    if (expandedColumnId === null) return 1

    const boardScrollEl = document.querySelector('.board-scroll')
    const boardScrollWidth = boardScrollEl ? boardScrollEl.offsetWidth : window.innerWidth
    const cardWidth = 260
    const gap = 8
    const padding = 40
    const availableWidth = boardScrollWidth - padding
    return Math.max(1, Math.floor((availableWidth + gap) / (cardWidth + gap)))
  }

  return (
    <div className="board-scroll">
      <div className="board">
        {reviewDateStages.map((stage) => {
          const filtered = getFilteredCardsForStage(stage.id)
          const sorted = sortCards(filtered)
          const isExpanded = expandedColumnId === stage.id
          const hasExpanded = expandedColumnId !== null

          if (filtered.length === 0 && !isExpanded) {
            return null
          }

          if (hasExpanded && !isExpanded) {
            return null
          }

          const numColumns = isExpanded ? calculateColumns(filtered) : 1

          return (
            <div
              key={stage.id}
              className={`board-column ${isExpanded ? 'expanded' : ''}`}
              data-stage={stage.id}
            >
              <Card
                size="small"
                className="gx-card"
                style={{
                  borderRadius: '10px',
                  width: isExpanded ? '100%' : '260px',
                  display: filtered.length === 0 ? 'none' : 'block'
                }}
                bodyStyle={{
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* Custom Header - Replaces Card title to avoid blue header */}
                <div className="board-column-header"
                  style={{ borderRadius: '10px 10px 0 0', borderBottom: '0.2px' }}>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span className="column-title">{stage.label}</span>
                    <span className="column-count">{filtered.length}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {stage.subtitle && <span className="wip">{stage.subtitle}</span>}
                    <Button
                      type={isExpanded ? 'primary' : 'default'}
                      size="small"
                      onClick={() => onToggleExpand(stage.id)}
                      title={isExpanded ? 'Collapse' : 'Expand'}
                    >
                      <Icon type={isExpanded ? 'shrink' : 'arrows-alt'} />
                    </Button>
                  </div>
                </div>

                <div
                  className={`column-body ${isExpanded ? 'expanded' : ''}`}
                  style={{
                    padding: '10px',
                    maxHeight: isExpanded ? 'none' : 'calc(100vh - 200px)',
                    overflowY: isExpanded ? 'visible' : 'auto',
                    overflowX: 'visible',
                    flex: 1,
                    minHeight: 0
                  }}
                >
                  {isExpanded ? (
                    <>
                      {Array.from({ length: numColumns }).map((_, colIndex) => (
                        <div key={colIndex} style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '260px', flexShrink: 0 }}>
                          {sorted
                            .filter((_, index) => index % numColumns === colIndex)
                            .map((card) => (
                              <JobCard key={card.jobCardNo} card={card} onClick={() => onCardClick(card)} />
                            ))}
                        </div>
                      ))}
                    </>
                  ) : (
                    sorted.map((card) => (
                      <JobCard key={card.jobCardNo} card={card} onClick={() => onCardClick(card)} />
                    ))
                  )}
                </div>
              </Card>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Board

